module.exports = __webpack_public_path__ + "static/media/Nursery_5.6fb1f985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/nursery/Nursery_5.png
// module id = 1284
// module chunks = 3